// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Variants from '../components/Variants';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    user: state.auth.user,
    store: state.store.store,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({}, dispatch)
)(Variants);
